// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.contractContainer.financialData.paymentMethods.';

const CARD = `${DOMAIN}card`,
  IBAN = `${DOMAIN}iban`;

export { CARD, IBAN };
